// extracted by mini-css-extract-plugin
export var smallSpinner = "_xc-0";